
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';

const AgencyDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [agencyData, setAgencyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (id) {
      fetchAgencyDetails();
    }
  }, [id]);

  const fetchAgencyDetails = async () => {
    try {
      setLoading(true);
      
      const data = await apiService.get(`/agencies/${id}`);
      setAgencyData(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching agency details:', err);
      setError('Failed to load agency details');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setAgencyData({
      ...agencyData,
      [field]: value
    });
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      const requestBody = {
        userId: 3,
        agencyName: agencyData.agencyName || "",
        description: agencyData.description || "",
        contactPerson: agencyData.contactPerson || "",
        contactNumber: agencyData.contactNumber || "",
        emailAddress: agencyData.emailAddress || ""
      };

      const result = await apiService.put(`/agencies/?id=${id}`, requestBody);
      console.log('Agency updated successfully:', result);
      
      // Optionally refresh the agency data
      await fetchAgencyDetails();
      
      alert('Agency updated successfully!');
      
    } catch (err) {
      console.error('Error updating agency:', err);
      alert('Failed to update agency. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Agency Details</h1>
        </div>
        <div className="loading-state">
          <p>Loading agency details...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Agency Details</h1>
        </div>
        <div className="error-state">
          <p>{error}</p>
          <button onClick={fetchAgencyDetails} className="retry-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  if (!agencyData) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Agency Details</h1>
        </div>
        <div className="error-state">
          <p>Agency not found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="manage-properties">
      <div className="page-header">
        <h1>Agency Details</h1>
      </div>

      <div className="content-container">
        <div className="form-section">
          <h3>Agency Information</h3>
          <div className="form-grid">
            <div className="form-row">
              <label htmlFor="agencyName">Agency Name:</label>
              <input
                type="text"
                id="agencyName"
                className="form-input"
                value={agencyData.agencyName || ''}
                onChange={(e) => handleInputChange('agencyName', e.target.value)}
              />
            </div>
            
            <div className="form-row">
              <label htmlFor="description">Description:</label>
              <textarea
                id="description"
                className="form-textarea"
                value={agencyData.description || ''}
                onChange={(e) => handleInputChange('description', e.target.value)}
                rows="3"
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Contact Information</h3>
          <div className="form-grid">
            <div className="form-row">
              <label htmlFor="contactPerson">Contact Person:</label>
              <input
                type="text"
                id="contactPerson"
                className="form-input"
                value={agencyData.contactPerson || ''}
                onChange={(e) => handleInputChange('contactPerson', e.target.value)}
              />
            </div>
            
            <div className="form-row">
              <label htmlFor="contactNumber">Contact Number:</label>
              <input
                type="text"
                id="contactNumber"
                className="form-input"
                value={agencyData.contactNumber || ''}
                onChange={(e) => handleInputChange('contactNumber', e.target.value)}
              />
            </div>
            
            <div className="form-row">
              <label htmlFor="emailAddress">Email Address:</label>
              <input
                type="email"
                id="emailAddress"
                className="form-input"
                value={agencyData.emailAddress || ''}
                onChange={(e) => handleInputChange('emailAddress', e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button 
            type="button" 
            className="btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgencyDetails;